import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FORM_ERROR_LIST, LOCALIZATION_DATA_LIST } from './token';
import { Locales } from './locales';
import { map } from 'rxjs/operators';

const localStorageKey = 'lang';

const localeSubject = new BehaviorSubject<Locales | null>(null);

@Injectable()
export class LocalizationService {
  private localeSubject = localeSubject;
  private localizationData: { [key: string]: { [key: string]: string } } = {};
  private formErrorLocalization: { [key: string]: { [key: string]: string } } =
    {};

  get locale$() {
    return this.localeSubject.asObservable().pipe(
      map(lang => {
        if (!lang) {
          this.initializeLang();
        }
        return this.localeSubject.value;
      })
    );
  }

  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  localize(key: string): string {
    const localeId = this.getLocale() as string;
    if (!this.localizationData[localeId]) {
      this.localizationData[localeId] = (this.injector.get(
        LOCALIZATION_DATA_LIST
      ) || ({} as any))[localeId];
    }
    return this.localizationData[localeId][key];
  }

  formErrorLocalize(key: string): string {
    const localeId = this.getLocale() as string;
    if (!this.formErrorLocalization[localeId]) {
      this.formErrorLocalization[localeId] = (this.injector.get(
        FORM_ERROR_LIST
      ) || ({} as any))[localeId];
    }
    return this.formErrorLocalization[localeId][key];
  }

  setLocale(localeId: Locales) {
    if (this.getLocale() !== localeId) {
      this.localeSubject.next(localeId);
    }
  }

  getLocale(): Locales | null {
    if (!this.localeSubject.value) {
      this.initializeLang();
    }
    return this.localeSubject.value;
  }

  private initializeLang(): void {
    this.localeSubject.next(Locales.ru);
  }
}

function getLang(lang: string | null): Locales | null {
  if (!lang) {
    return null;
  }
  // @ts-ignore
  return Locales[Object.keys(Locales)[Object.values(Locales).indexOf(lang)]];
}
